
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import slider1 from '../asstes/slider1.jpeg';
import slider2 from '../asstes/slider2.jpeg';
import slider3 from '../asstes/slider3.jpeg';
import slider4 from '../asstes/slider4.jpeg';
import slider5 from '../asstes/slider5.jpeg';
import slider6 from '../asstes/slider6.jpeg';
import cmImage from '../asstes/CM.jpg';
import dcmImage from '../asstes/DCM.jpg';
import dcm1Image from '../asstes/DCM1.png';
import jaykumarImage from '../asstes/slider5.jpeg';
import additionalChiefImage from '../asstes/AdditionalChiefEcutiveOfficer.jpeg';
import ceoImage from '../asstes/ChiefExecutiveOfficerZillaParishadSangli.jpeg';
import deputyCeoImage from '../asstes/DeputyChiefExecutiveOfficerGramPanchayatDepartment.jpeg';
import sarpanchImage from '../asstes/sarpnch.jpeg';
import deputySarpanchImage from '../asstes/DeputySarpanch.jpeg';
import villageDevelopmentOfficerImage from '../asstes/gramsevak.jpeg';

// Import gallery images
import gallery1 from '../asstes/gallery/1 .jpeg';
import gallery2 from '../asstes/gallery/2 .jpeg';
import gallery3 from '../asstes/gallery/3 .jpeg';
import gallery4 from '../asstes/gallery/4 .jpeg';
import gallery5 from '../asstes/gallery/5 .jpeg';
import gallery6 from '../asstes/gallery/6.jpeg';
import gallery75 from '../asstes/gallery/75.jpeg';

// Mock data - In real app, this would come from API
const leadersData = [
  {
    id: 1,
    name: { marathi: 'श्री. देवेंद्र फडणवीस', english: 'Shri. Devendra Fadnavis' },
    designation: { marathi: 'माननीय मुख्यमंत्री', english: 'Hon. Chief Minister' },
    image: cmImage
  },
  {
    id: 2,
    name: { marathi: 'श्री. एकनाथ शिंदे', english: 'Shri. Eknath Shinde' },
    designation: { marathi: 'माननीय उपमुख्यमंत्री', english: 'Hon. Deputy Chief Minister' },
    image: dcmImage
  },
  {
    id: 3,
    name: { marathi: 'श्रीमती. सुनेत्रा अजित पवार', english: 'Smt. Sunetra Ajit Pawar' },
    designation: { marathi: 'माननीय उपमुख्यमंत्री', english: 'Hon. Deputy Chief Minister' },
    image: dcm1Image
  },
  {
    id: 4,
    designation: { marathi: 'माननीय ग्रामविकास मंत्री', english: 'Hon. Rural Development Minister' },
    name: { marathi: 'श्री. जयकुमार गोरे', english: 'Shri. Jaykumar Gore' },
    image: jaykumarImage
  }
];

const zillaParishadData = [
  {
    id: 1,
    name: { marathi: 'श्री.मनोज जाधव', english: 'Shri. Manoj Jadhav' },
    designation: { marathi: 'अतिरिक्त मुख्य कार्यकारी अधिकारी\nजिल्हा परिषद, सांगली', english: 'Additional CEO\nZilla Parishad, Sangli' },
    image: additionalChiefImage
  },
  {
    id: 2,
    name: { marathi: 'श्री. विशाल नरवाडे (भा.प्र.से)', english: 'Shri. Vishal Narwade (IAS)' },
    designation: { marathi: 'मुख्य कार्यकारी अधिकारी\nजिल्हा परिषद, सांगली', english: 'Chief Executive Officer\nZilla Parishad, Sangli' },
    image: ceoImage
  },
  {
    id: 3,
    name: { marathi: 'श्री. शशिकांत शिंदे', english: 'Shri. Shashikant Shinde' },
    designation: { marathi: 'उप मुख्य कार्यकारी अधिकारी\nग्रामपंचायत विभाग', english: 'Deputy CEO\nGram Panchayat Dept' },
    image: deputyCeoImage
  }
];

const panchayatOfficialsData = [
  {
    id: 1,
    name: { marathi: 'श्रीमती.अश्विनी अमोल कोळी', english: 'Smt. Ashwini Amol Koli' },
    designation: { marathi: 'सरपंच', english: 'Sarpanch' },
    phone: '9876543210',
    tenure: '2022-2027',
    image: sarpanchImage
  },
  {
    id: 2,
    name: { marathi: 'श्रीमती.अनीता महावीर पाटील', english: 'Smt. Anita Mahavir Patil' },
    designation: { marathi: 'उपसरपंच', english: 'Deputy Sarpanch' },
    phone: '9876543211',
    tenure: '2022-2027',
    image: deputySarpanchImage
  },
  {
    id: 3,
    name: { marathi: 'श्रीमती.अस्मिता चव्हान', english: 'Smt. Asmita Chavan' },
    designation: { marathi: 'ग्रामविकास अधिकारी', english: 'Village Dev Officer' },
    phone: '9876543212',
    tenure: '2020-2025',
    image: villageDevelopmentOfficerImage
  }
];

const servicesData = [
  { id: 1, name: { marathi: 'घरपट्टी', english: 'House Tax' }, icon: '🏠', color: 'bg-blue-500' },
  { id: 2, name: { marathi: 'पाणीपट्टी', english: 'Water Tax' }, icon: '🚰', color: 'bg-cyan-500' },
  { id: 3, name: { marathi: 'दाखले', english: 'Certificates' }, icon: '📄', color: 'bg-emerald-500' },
  { id: 4, name: { marathi: 'तक्रार नोंदणी', english: 'Complaints' }, icon: '📝', color: 'bg-amber-500' }
];

const noticesData = [
  { id: 1, title: { marathi: 'ग्रामसभा सूचना', english: 'Gramsabha Notice' }, date: { marathi: '१५ डिसेंबर २०२३', english: '15 Dec 2023' }, category: 'important' },
  { id: 2, title: { marathi: 'निविदा जाहिरात', english: 'Tender Ad' }, date: { marathi: '१० डिसेंबर २०२३', english: '10 Dec 2023' }, category: 'tender' },
  { id: 3, title: { marathi: 'स्वच्छता अभियान', english: 'Sanitation Campaign' }, date: { marathi: '५ डिसेंबर २०२३', english: '5 Dec 2023' }, category: 'general' },
  { id: 4, title: { marathi: 'पाणीपुरवठा बंद', english: 'Water Supply Off' }, date: { marathi: '१ डिसेंबर २०२३', english: '1 Dec 2023' }, category: 'important' }
];

const galleryData = [
  { id: 1, image: gallery1, alt: 'Gallery Image 1' },
  { id: 2, image: gallery2, alt: 'Gallery Image 2' },
  { id: 3, image: gallery3, alt: 'Gallery Image 3' },
  { id: 4, image: gallery4, alt: 'Gallery Image 4' },
  { id: 5, image: gallery5, alt: 'Gallery Image 5' },
  { id: 6, image: gallery6, alt: 'Gallery Image 6' },
  { id: 7, image: gallery75, alt: 'Gallery Image 7' }
];

const WebsiteHome = () => {
  const { language } = useLanguage();
  const [activeSlide, setActiveSlide] = useState(0);
  const [activeTab, setActiveTab] = useState('important');
  const [showImportantDropdown, setShowImportantDropdown] = useState(false);
  const [showCertificatesDropdown, setShowCertificatesDropdown] = useState(false);
  const [showMarketDropdown, setShowMarketDropdown] = useState(false);

  const leadersRef = useRef(null);
  const zillaParishadRef = useRef(null);
  const gramPanchayatRef = useRef(null);

  // Auto-scroll logic for mobile sliders (Seamless Infinite Loop)
  useEffect(() => {
    const scrollContainers = [leadersRef.current, zillaParishadRef.current, gramPanchayatRef.current];
    let intervalId;

    const autoScroll = () => {
      // Only auto-scroll on mobile views
      if (window.innerWidth < 768) {
        scrollContainers.forEach(container => {
          if (container && container.children.length > 0) {
            const cardElement = container.children[0];
            const gap = container.classList.contains('gap-8') ? 32 : 24;
            const itemWidth = cardElement.offsetWidth + gap;
            
            // Smoothly scroll exactly one item forward
            container.scrollBy({ left: itemWidth, behavior: 'smooth' });

            // Wait for smooth scroll animation to finish before silently resetting
            setTimeout(() => {
              // The container has duplicated items, so original count is half the total children
              const originalCount = container.children.length / 2;
              const resetPosition = originalCount * itemWidth;
              
              // If we've reached the duplicated items, jump back silently to the exact identical original item
              if (container.scrollLeft >= resetPosition - 10) {
                container.scrollBy({ left: -resetPosition, behavior: 'auto' });
              }
            }, 600); // 600ms gives time for scroll to finish
          }
        });
      }
    };

    intervalId = setInterval(autoScroll, 2500); // Slide every 2.5 seconds

    return () => clearInterval(intervalId);
  }, []);

  const sliderImages = [
    slider1,
    slider2,
    slider3,
    slider4,
    slider5,
    slider6
  ];

  const [slidesPerView, setSlidesPerView] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setSlidesPerView(1);
      else if (window.innerWidth < 1024) setSlidesPerView(2);
      else setSlidesPerView(3);
    };
    handleResize(); // Set initial value
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const visibleSlides = [];
  for (let i = 0; i < sliderImages.length; i += slidesPerView) {
    visibleSlides.push(sliderImages.slice(i, i + slidesPerView));
  }

  // Ensure activeSlide is within bounds when changing slidesPerView
  useEffect(() => {
    if (activeSlide >= visibleSlides.length) {
      setActiveSlide(0);
    }
  }, [slidesPerView, visibleSlides.length, activeSlide]);

  // Auto-slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % visibleSlides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [visibleSlides.length]);

  // Counter animation effect
  useEffect(() => {
    const counters = document.querySelectorAll('.counter-number');
    const speed = 100; // Faster animation
    const observerOptions = {
      threshold: 0.5,
      rootMargin: '0px'
    };

    const animateCounter = (counter) => {
      const target = +counter.getAttribute('data-target');
      const increment = target / speed;
      let current = 0;

      const updateCounter = () => {
        current += increment;
        if (current < target) {
          // Add formatting for better visual effect
          if (target === 1) {
            counter.innerText = '१'; // Marathi digit for 1
          } else {
            counter.innerText = Math.ceil(current).toLocaleString('mr-IN');
          }

          // Add pulse effect during animation
          counter.style.transform = 'scale(1.05)';
          setTimeout(() => {
            counter.style.transform = 'scale(1)';
          }, 50);

          requestAnimationFrame(updateCounter);
        } else {
          // Final value with proper formatting
          if (target === 1) {
            counter.innerText = '१';
          } else {
            counter.innerText = target.toLocaleString('mr-IN');
          }

          // Add completion effect
          counter.style.transform = 'scale(1.1)';
          setTimeout(() => {
            counter.style.transform = 'scale(1)';
          }, 200);
        }
      };

      updateCounter();
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const counter = entry.target;
          // Reset counter to 0 before starting animation
          counter.innerText = '०';
          animateCounter(counter);
          observer.unobserve(counter);
        }
      });
    }, observerOptions);

    counters.forEach(counter => {
      observer.observe(counter);
    });

    return () => {
      counters.forEach(counter => {
        observer.unobserve(counter);
      });
    };
  }, []);

  const goToSlide = (index) => {
    setActiveSlide(index);
  };

  const nextSlide = () => {
    setActiveSlide((prev) => (prev + 1) % visibleSlides.length);
  };

  const prevSlide = () => {
    setActiveSlide((prev) => (prev - 1 + visibleSlides.length) % visibleSlides.length);
  };

  return (
    <div className="min-h-screen bg-gray-50">

      {/* ── HERO SLIDER ── Proper horizontal sliding ── */}
      <section className="relative h-[500px] w-full overflow-hidden">
        {/* The sliding container */}
        <div
          className="flex h-full transition-transform duration-1000 ease-in-out"
          style={{ transform: `translateX(-${activeSlide * 100}%)` }}
        >
          {visibleSlides.map((slideGroup, groupIndex) => (
            <div
              key={groupIndex}
              className={`min-w-full h-full grid gap-0 flex-shrink-0 ${slidesPerView === 1 ? 'grid-cols-1' : slidesPerView === 2 ? 'grid-cols-2' : 'grid-cols-3'
                }`}
            >
              {slideGroup.map((image, imageIndex) => (
                <div
                  key={imageIndex}
                  className="relative overflow-hidden"
                >
                  <div
                    className="h-full w-full bg-cover bg-center transition-transform duration-700 hover:scale-110"
                    style={{ backgroundImage: `url(${image})` }}
                  >
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* Navigation arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/30 hover:bg-white/50 text-white p-4 rounded-full transition-all duration-300 backdrop-blur-sm border border-white/40 shadow-xl z-10 hover:scale-110"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/30 hover:bg-white/50 text-white p-4 rounded-full transition-all duration-300 backdrop-blur-sm border border-white/40 shadow-xl z-10 hover:scale-110"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M9 5l7 7-7 7" />
          </svg>
        </button>

        {/* Dots / Indicators */}
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex space-x-3 z-10">
          {visibleSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`transition-all duration-300 rounded-full ${index === activeSlide
                ? 'bg-white w-10 h-3 shadow-lg shadow-white/50'
                : 'bg-white/50 w-3 h-3 hover:bg-white/80'
                }`}
            />
          ))}
        </div>

        {/* Slide counter */}
        <div className="absolute top-4 right-4 bg-black/40 backdrop-blur-sm px-4 py-1 rounded-full text-white text-sm font-medium z-10">
          {activeSlide + 1} / {visibleSlides.length}
        </div>
      </section>


      {/* Services Section - Three Separate Cards */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex justify-center">
            <div className="w-full max-w-5xl">
              {/* Section Header - सरकारी शीर्षक */}
              <div className="text-center mb-10">

                <h2 className="text-3xl font-bold text-gray-800 mb-2">{language === 'marathi' ? 'डिजिटल ग्रामपंचायत सेवा केंद्र' : 'Digital Gram Panchayat Service Center'}</h2>
                {/* <p className="text-gray-600 max-w-2xl mx-auto">सर्व सरकारी सेवा ऑनलाइन - सुलभ, सुरक्षित व त्वरीत</p> */}
              </div>

              {/* Main Service Cards */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

                {/* Mobile View Tax Tabs - New Style */}
                <div className="block lg:hidden flex flex-col gap-3">
                  <div className="flex items-center justify-center space-x-2 px-1">
                    <span className="text-xl">📋</span>
                    <h3 className="text-xl font-bold text-gray-800">{language === 'marathi' ? 'ऑनलाईन कर भरणा' : 'Online Tax Payment'}</h3>
                  </div>
                  <div className="grid grid-cols-2 gap-4 h-full">
                    {/* पाणीपट्टी भरणे */}
                    <Link to="/Paywatertax" className="bg-white rounded-[1.25rem] p-4 sm:p-6 shadow-[0_2px_12px_-4px_rgba(0,0,0,0.08)] border border-gray-100 flex flex-col items-center justify-center gap-3 sm:gap-4 hover:shadow-md transition-all duration-300 group cursor-pointer h-full min-h-[150px]">
                      <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-[#fff4e5] flex items-center justify-center group-hover:bg-[#ffedd5] transition-colors">
                        <svg className="w-8 h-8 sm:w-10 sm:h-10 text-[#f97316]" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 21.5c-3.59 0-6.5-2.91-6.5-6.5 0-3.5 4.5-10.5 6.16-12.82.16-.23.44-.37.74-.37.3 0 .58.14.74.37 1.66 2.32 6.16 9.32 6.16 12.82 0 3.59-2.91 6.5-6.5 6.5z" />
                        </svg>
                      </div>
                      <span className="text-[#374151] font-bold text-sm sm:text-[15px] text-center">
                        {language === 'marathi' ? 'पाणीपट्टी भरणे' : 'Water Tax'}
                      </span>
                    </Link>

                    {/* घरपट्टी भरणे */}
                    <Link to="/Housetax" className="bg-white rounded-[1.25rem] p-4 sm:p-6 shadow-[0_2px_12px_-4px_rgba(0,0,0,0.08)] border border-gray-100 flex flex-col items-center justify-center gap-3 sm:gap-4 hover:shadow-md transition-all duration-300 group cursor-pointer h-full min-h-[150px]">
                      <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-[#fff4e5] flex items-center justify-center group-hover:bg-[#ffedd5] transition-colors">
                        <svg className="w-8 h-8 sm:w-10 sm:h-10 text-[#f97316]" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                        </svg>
                      </div>
                      <span className="text-[#374151] font-bold text-sm sm:text-[15px] text-center">
                        {language === 'marathi' ? 'घरपट्टी भरणे' : 'House Tax'}
                      </span>
                    </Link>
                  </div>
                </div>

                {/* Desktop View Tax - Blue Theme */}
                <div className="hidden lg:block relative group">
                  <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 h-full">
                    {/* Card Header with Government Seal */}
                    <div className="relative bg-[#f2ede4] border-b border-gray-200 p-6">

                      <div className="flex items-center space-x-4">
                        <div className="bg-white p-3 rounded-lg shadow-sm">
                          <span className="text-2xl text-blue-700">📋</span>
                        </div>
                        <div>
                          <h3 className="text-xl font-bold text-black">{language === 'marathi' ? 'ऑनलाईन कर भरणा' : 'Online Tax Payment'}</h3>
                          <p className="text-black text-sm">{language === 'marathi' ? 'महत्त्वाची माहिती' : 'Important Information'}</p>
                        </div>
                      </div>
                    </div>

                    {/* Card Content */}
                    <div className="p-6">
                      <button
                        onClick={() => setShowImportantDropdown(!showImportantDropdown)}
                        className={`w-full py-4 px-4 rounded-lg font-bold transition-all duration-300 flex items-center justify-between ${showImportantDropdown
                            ? 'bg-gray-50 text-blue-800 border-2 border-blue-300'
                            : 'bg-gray-50 text-blue-700 hover:bg-gray-50 border border-blue-200'
                          }`}
                      >
                        <div className="flex items-center space-x-3">
                          <div className="bg-white p-2 rounded-lg">
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                          </div>
                          <span>{language === 'marathi' ? 'सेवा निवडा' : 'Select Service'}</span>
                        </div>
                        <svg
                          className={`w-5 h-5 transition-transform duration-300 ${showImportantDropdown ? 'rotate-180' : ''}`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>

                      {/* Dropdown Menu - Large */}
                      {showImportantDropdown && (
                        <div className="mt-4 animate-fadeIn">
                          <div className="grid grid-cols-2 gap-3">
                            <a href="/Housetax" className="block p-3 bg-white rounded-xl border border-gray-100 hover:bg-blue-50 hover:border-blue-200 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group">
                              <div className="flex items-center space-x-3">
                                <div className="bg-blue-50/60 p-2.5 rounded-lg border border-blue-100/50 group-hover:bg-white group-hover:shadow-sm group-hover:scale-110 transition-all duration-300">
                                  <span className="text-xl">🏠</span>
                                </div>
                                <div>
                                  <div className="font-bold text-gray-800 text-sm group-hover:text-blue-700 transition-colors">{language === 'marathi' ? 'घरपट्टी भरणे' : 'Pay House Tax'}</div>
                                  <div className="text-xs text-gray-500 line-clamp-1">House Tax Payment</div>
                                </div>
                              </div>
                            </a>

                            <a href="/Paywatertax" className="block p-3 bg-white rounded-xl border border-gray-100 hover:bg-blue-50 hover:border-blue-200 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group">
                              <div className="flex items-center space-x-3">
                                <div className="bg-blue-50/60 p-2.5 rounded-lg border border-blue-100/50 group-hover:bg-white group-hover:shadow-sm group-hover:scale-110 transition-all duration-300">
                                  <span className="text-xl">💧</span>
                                </div>
                                <div>
                                  <div className="font-bold text-gray-800 text-sm group-hover:text-blue-700 transition-colors">{language === 'marathi' ? 'पाणीपट्टी भरणे' : 'Pay Water Tax'}</div>
                                  <div className="text-xs text-gray-500 line-clamp-1">Water Tax Payment</div>
                                </div>
                              </div>
                            </a>
                          </div>

                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Mobile View Certificates Tabs - New Style */}
                <div className="block lg:hidden flex flex-col gap-3">
                  <div className="flex items-center justify-center space-x-2 px-1">
                    <span className="text-xl">🏛️</span>
                    <h3 className="text-xl font-bold text-gray-800">{language === 'marathi' ? 'दाखले / प्रमाणपत्रे' : 'Certificates / Documents'}</h3>
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 h-full">
                    {[
                      {
                        marathi: 'जन्म प्रमाणपत्र',
                        english: 'Birth Certificate',
                        svg: (
                          <svg className="w-8 h-8 sm:w-10 sm:h-10 text-[#f97316]" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                          </svg>
                        )
                      },
                      {
                        marathi: 'मृत्यू प्रमाणपत्र',
                        english: 'Death Certificate',
                        svg: (
                          <svg className="w-8 h-8 sm:w-10 sm:h-10 text-[#f97316]" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                            <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
                          </svg>
                        )
                      },
                      {
                        marathi: 'विवाह प्रमाणपत्र',
                        english: 'Marriage Certificate',
                        svg: (
                          <svg className="w-8 h-8 sm:w-10 sm:h-10 text-[#f97316]" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                          </svg>
                        )
                      },
                      {
                        marathi: 'BPL प्रमाणपत्र',
                        english: 'BPL Certificate',
                        svg: (
                          <svg className="w-8 h-8 sm:w-10 sm:h-10 text-[#f97316]" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z" />
                            <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z" />
                          </svg>
                        )
                      },
                      {
                        marathi: 'येणेबाकी नाही',
                        english: 'No Dues Cert',
                        svg: (
                          <svg className="w-8 h-8 sm:w-10 sm:h-10 text-[#f97316]" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                          </svg>
                        )
                      },
                      {
                        marathi: '८ / ७ उतारा',
                        english: 'Form 8/7',
                        svg: (
                          <svg className="w-8 h-8 sm:w-10 sm:h-10 text-[#f97316]" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z" />
                            <path d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" />
                          </svg>
                        )
                      },
                      {
                        marathi: 'निराधार दाखला',
                        english: 'Destitute Cert',
                        svg: (
                          <svg className="w-8 h-8 sm:w-10 sm:h-10 text-[#f97316]" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
                          </svg>
                        )
                      }
                    ].map((cert, idx) => (
                      <Link key={idx} to="/certificate-selection" className="bg-white rounded-[1.25rem] p-3 sm:p-4 shadow-[0_2px_12px_-4px_rgba(0,0,0,0.08)] border border-gray-100 flex flex-col items-center justify-center gap-2 hover:shadow-md transition-all duration-300 group cursor-pointer h-full min-h-[130px]">
                        <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#fff4e5] flex items-center justify-center group-hover:bg-[#ffedd5] transition-colors">
                          {cert.svg}
                        </div>
                        <span className="text-[#374151] font-bold text-xs sm:text-sm text-center px-1">
                          {language === 'marathi' ? cert.marathi : cert.english}
                        </span>
                      </Link>
                    ))}
                  </div>
                </div>

                {/* Desktop View Certificates - Green Theme */}
                <div className="hidden lg:block relative group">
                  <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 h-full">
                    {/* Card Header */}
                    <div className="relative bg-[#f2ede4] border-b border-gray-200 p-6">

                      <div className="flex items-center space-x-4">
                        <div className="bg-white p-3 rounded-lg shadow-sm">
                          <span className="text-2xl text-green-700">🏛️</span>
                        </div>
                        <div>
                          <h3 className="text-xl font-bold text-black">{language === 'marathi' ? 'दाखले / प्रमाणपत्रे' : 'Certificates / Documents'}</h3>
                          <p className="text-black text-sm">Certificates & Documents</p>
                        </div>
                      </div>
                    </div>

                    {/* Card Content */}
                    <div className="p-6">
                      <button
                        onClick={() => setShowCertificatesDropdown(!showCertificatesDropdown)}
                        className={`w-full py-4 px-4 rounded-lg font-bold transition-all duration-300 flex items-center justify-between ${showCertificatesDropdown
                          ? 'bg-gray-50 text-green-800 border-2 border-green-300'
                          : 'bg-gray-50 text-green-700 hover:bg-gray-50 border border-green-200'
                          }`}
                      >
                        <div className="flex items-center space-x-3">
                          <div className="bg-white p-2 rounded-lg">
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                          </div>
                          <span>{language === 'marathi' ? 'प्रमाणपत्र निवडा' : 'Select Certificate'}</span>
                        </div>
                        <svg
                          className={`w-5 h-5 transition-transform duration-300 ${showCertificatesDropdown ? 'rotate-180' : ''}`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>

                      {/* Dropdown Menu - Large with Scroll */}
                      {showCertificatesDropdown && (
                        <div className="mt-4 animate-fadeIn">
                          <div className="grid grid-cols-2 gap-2 max-h-80 overflow-y-auto pr-2">
                            {[
                              { icon: "👶", title: { marathi: "जन्म प्रमाणपत्र", english: "Birth Certificate" }, desc: "Birth Certificate" },
                              { icon: "⚰️", title: { marathi: "मृत्यू प्रमाणपत्र", english: "Death Certificate" }, desc: "Death Certificate" },
                              { icon: "💍", title: { marathi: "विवाह प्रमाणपत्र", english: "Marriage Certificate" }, desc: "Marriage Certificate" },
                              { icon: "📊", title: { marathi: "दारिद्र्य रेषेखालील प्रमाणपत्र", english: "BPL Certificate" }, desc: "BPL Certificate" },
                              { icon: "🏛️", title: { marathi: "येणेबाकी नसल्याचा दाखला", english: "No Dues Certificate" }, desc: "No Dues Certificate" },
                              { icon: "📑", title: { marathi: "नमुना ८ / ७ उतारा", english: "Form 8/7 Extract" }, desc: "Form 8/7 Extract" },
                              { icon: "🆘", title: { marathi: "निराधार असल्याचा दाखला", english: "Destitute Certificate" }, desc: "Destitute Certificate" }
                            ].map((cert, index) => (
                              <Link
                                key={index}
                                to="/certificate-selection"
                                className="block p-3 bg-white rounded-xl border border-gray-100 hover:bg-green-50 hover:border-green-200 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group"
                              >
                                <div className="flex items-center space-x-3">
                                  <div className="bg-green-50/60 p-2.5 rounded-lg border border-green-100/50 group-hover:bg-white group-hover:shadow-sm group-hover:scale-110 transition-all duration-300">
                                    <span className="text-xl">{cert.icon}</span>
                                  </div>
                                  <div>
                                    <div className="font-bold text-gray-800 text-sm group-hover:text-green-700 transition-colors">{cert.title[language] || cert.title.marathi}</div>
                                    <div className="text-xs text-gray-500 line-clamp-1">{cert.desc}</div>
                                  </div>
                                </div>
                              </Link>
                            ))}
                          </div>

                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Government Footer Info */}

            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  .animate-fadeIn {
    animation: fadeIn 0.3s ease-out;
  }
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  .hide-scrollbar::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  .hide-scrollbar {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
`}</style>

      {/* माननीय मंत्री Section - Below Cards */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-10">
            <div className="inline-block px-4 py-1 bg-gray-50 rounded-full mb-2">
              <span className="text-blue-800 font-semibold">{language === 'marathi' ? 'नेतृत्व' : 'Leadership'}</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              {language === 'marathi' ? 'माननीय मंत्री' : 'Honorable Ministers'}
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-amber-500 mx-auto"></div>
          </div>

          <div ref={leadersRef} className="flex md:grid overflow-x-auto md:overflow-visible snap-x snap-mandatory md:snap-none pb-6 md:pb-0 gap-6 md:grid-cols-2 lg:grid-cols-4 hide-scrollbar">
            {[...leadersData, ...leadersData].map((leader, index) => (
              <div
                key={`${leader.id}-${index}`}
                className={`min-w-[85vw] sm:min-w-[45vw] md:min-w-0 snap-center shrink-0 bg-gray-50 rounded-xl p-6 shadow-lg border border-blue-100 hover:shadow-xl transition-shadow duration-300 h-full ${index >= leadersData.length ? 'md:hidden' : ''}`}
              >
                <div className="flex flex-col items-center h-full">
                  <div className="flex-shrink-0 mb-4">
                    <img
                      src={leader.image}
                      alt={leader.name}
                      className="w-32 h-32 object-cover rounded-lg border-4 border-white shadow-md"
                    />
                  </div>
                  <div className="flex-grow flex flex-col justify-center text-center">
                    <h3 className="text-lg font-bold text-blue-900 mb-2">{leader.designation[language] || leader.designation.marathi}</h3>
                    <p className="text-blue-700 text-sm">{leader.name[language] || leader.name.marathi}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* जिल्हा परिषद प्रशासन */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-10">
            <div className="inline-block px-4 py-1 bg-gray-50 rounded-full mb-2">
              <span className="text-cyan-800 font-semibold">{language === 'marathi' ? 'विभाग' : 'Department'}</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-cyan-900 mb-4">
              {language === 'marathi' ? 'जिल्हा परिषद प्रशासन – सांगली' : 'Zilla Parishad Admin - Sangli'}
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-cyan-600 to-blue-500 mx-auto"></div>
          </div>

          <div ref={zillaParishadRef} className="flex md:grid overflow-x-auto md:overflow-visible snap-x snap-mandatory md:snap-none pb-6 md:pb-0 gap-6 md:grid-cols-2 lg:grid-cols-3 hide-scrollbar">
            {[...zillaParishadData, ...zillaParishadData].map((officer, index) => (
              <div
                key={`${officer.id}-${index}`}
                className={`min-w-[85vw] sm:min-w-[45vw] md:min-w-0 snap-center shrink-0 bg-gray-50 rounded-xl p-6 shadow-lg border border-cyan-100 hover:shadow-xl transition-shadow duration-300 h-full ${index >= zillaParishadData.length ? 'md:hidden' : ''}`}
              >
                <div className="flex flex-col items-center h-full">
                  <div className="flex-shrink-0 mb-4">
                    <img
                      src={officer.image}
                      alt={officer.name}
                      className="w-32 h-40 object-cover rounded-lg border-4 border-white shadow-md"
                    />
                  </div>
                  <div className="flex-grow flex flex-col justify-center text-center">
                    <h3 className="text-lg font-bold text-cyan-900 mb-2">{officer.name[language] || officer.name.marathi}</h3>
                    <p className="text-cyan-700 text-sm whitespace-pre-line leading-relaxed">{officer.designation[language] || officer.designation.marathi}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ग्राम पंचायत पदाधिकारी */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-10">
            <div className="inline-block px-4 py-1 bg-sky-100 rounded-full mb-2">
              <span className="text-sky-800 font-semibold">{language === 'marathi' ? 'ग्रामपंचायत' : 'Gram Panchayat'}</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-sky-900 mb-4">
              {language === 'marathi' ? 'ग्राम पंचायत पदाधिकारी' : 'Panchayat Officials'}
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-sky-600 to-blue-500 mx-auto"></div>
          </div>

          <div ref={gramPanchayatRef} className="flex md:grid overflow-x-auto md:overflow-visible snap-x snap-mandatory md:snap-none pb-6 md:pb-0 gap-8 md:grid-cols-2 lg:grid-cols-3 hide-scrollbar">
            {[...panchayatOfficialsData, ...panchayatOfficialsData].map((official, index) => (
              <div
                key={`${official.id}-${index}`}
                className={`min-w-[85vw] sm:min-w-[45vw] md:min-w-0 snap-center shrink-0 bg-white rounded-xl p-6 shadow-lg border border-sky-100 hover:shadow-xl transition-shadow ${index >= panchayatOfficialsData.length ? 'md:hidden' : ''}`}
              >
                <div className="flex flex-col md:flex-row items-center md:items-start gap-6">
                  <img
                    src={official.image}
                    alt={official.name}
                    className="w-32 h-40 object-cover rounded-lg border-4 border-sky-100"
                  />
                  <div className="flex-1 text-center md:text-left">
                    <h3 className="text-xl font-bold text-sky-900 mb-2">{official.name[language] || official.name.marathi}</h3>
                    <p className="text-sky-700 font-medium mb-3">{official.designation[language] || official.designation.marathi}</p>
                    {official.phone && (
                      <p className="text-gray-600 mb-2">
                        <span className="font-semibold">{language === 'marathi' ? 'मोबाईल:' : 'Mobile:'}</span> {official.phone}
                      </p>
                    )}
                    <p className="text-gray-600">
                      <span className="font-semibold">{language === 'marathi' ? 'कार्यकाळ:' : 'Tenure:'}</span> {official.tenure}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* सूचना / नोटीस & फोटो गॅलरी Side by Side */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

            {/* सूचना / नोटीस */}
            <div className="bg-white rounded-xl shadow-lg border border-amber-100 p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-amber-900">{language === 'marathi' ? 'सूचना / नोटीस' : 'Notices'}</h2>
                <span className="bg-gray-50 text-amber-800 px-3 py-1 rounded-full text-sm font-medium">
                  {language === 'marathi' ? 'नवीन' : 'New'}
                </span>
              </div>

              <div className="space-y-4">
                {noticesData.map((notice) => (
                  <div
                    key={notice.id}
                    className="p-4 border border-amber-50 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <div className="flex items-start gap-3">
                      <div className={`w-3 h-12 rounded ${notice.category === 'important' ? 'bg-red-500' : notice.category === 'tender' ? 'bg-blue-500' : 'bg-amber-500'}`}></div>
                      <div className="flex-1">
                        <h3 className="font-bold text-gray-800 mb-1">{notice.title[language] || notice.title.marathi}</h3>
                        <p className="text-sm text-gray-600">{language === 'marathi' ? 'तारीख:' : 'Date:'} {notice.date[language] || notice.date.marathi}</p>
                      </div>
                      <button className="text-amber-600 hover:text-amber-800 font-medium">
                        {language === 'marathi' ? 'वाचा →' : 'Read →'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-6 text-center">
                <button className="text-amber-700 hover:text-amber-900 font-semibold">
                  {language === 'marathi' ? 'सर्व सूचना पहा →' : 'View All Notices →'}
                </button>
              </div>
            </div>

            {/* फोटो गॅलरी */}
            <div className="bg-white rounded-xl shadow-lg border border-violet-100 p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-bold text-violet-900">{language === 'marathi' ? 'फोटो गॅलरी' : 'Photo Gallery'}</h2>
                <span className="bg-violet-100 text-violet-800 px-3 py-1 rounded-full text-sm font-medium">
                  {language === 'marathi' ? '२४+ फोटो' : '24+ Photos'}
                </span>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {galleryData.slice(0, 6).map((item) => (
                  <div
                    key={item.id}
                    className="relative overflow-hidden rounded-lg group cursor-pointer"
                  >
                    <img
                      src={item.image}
                      alt={item.alt}
                      className="w-full h-40 object-cover transition-transform duration-300 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                ))}
              </div>

              <div className="mt-6 text-center">
                <Link
                  to="/gallery"
                  className="bg-[#f2ede4] text-black px-6 py-3 rounded-lg font-semibold hover:opacity-80 transition-all inline-block border border-gray-200"
                >
                  {language === 'marathi' ? 'View More गॅलरी →' : 'View More Gallery →'}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Counter Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-10">
            <div className="inline-block px-4 py-1 bg-gray-50 rounded-full mb-2">
              <span className="text-green-800 font-semibold">{language === 'marathi' ? 'आमच्या गावाची ओळख' : 'Our Village Identity'}</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {language === 'marathi' ? 'गावाची माहिती' : 'Village Information'}
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-green-600 to-emerald-500 mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Population Counter */}
            <div className="bg-gray-50 rounded-xl p-8 shadow-lg border border-green-100 hover:shadow-xl transition-all duration-300 text-center group">
              <div className="mb-4">
                <div className="w-20 h-20 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto group-hover:scale-110 transition-transform duration-300">
                  <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                  </svg>
                </div>
              </div>
              <div className="counter-number text-4xl font-bold text-green-800 mb-2 transition-all duration-300 ease-out" data-target="5432" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>०</div>
              <h3 className="text-xl font-bold text-green-900 mb-1">{language === 'marathi' ? 'आमच्या गावातील लोकसंख्या' : 'Our Village Population'}</h3>
              <p className="text-green-700 text-sm">{language === 'marathi' ? 'विविध समाज घटकांचे सौहार्दपूर्ण राहणीमान' : 'Harmonious living of various sections of society'}</p>
            </div>

            {/* Area Description Counter */}
            <div className="bg-gray-50 rounded-xl p-8 shadow-lg border border-blue-100 hover:shadow-xl transition-all duration-300 text-center group">
              <div className="mb-4">
                <div className="w-20 h-20 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full flex items-center justify-center mx-auto group-hover:scale-110 transition-transform duration-300">
                  <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2l-5.5 9h11z M12 22l5.5-9h-11z M3.5 9l5.5 9v-11z M20.5 9l-5.5 9v-11z" />
                  </svg>
                </div>
              </div>
              <div className="counter-number text-4xl font-bold text-blue-800 mb-2 transition-all duration-500 ease-in-out" data-target="1" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)', transform: 'scale(1.1)', opacity: 0.8 }}>०</div>
              <h3 className="text-xl font-bold text-blue-900 mb-1">{language === 'marathi' ? 'हे. मध्ये विस्तारलेले सुंदर व प्रगत गाव.' : 'Beautiful & developed village spread in Ha.'}</h3>
              <p className="text-blue-700 text-sm">{language === 'marathi' ? 'आधुनिक सुविधांनी समृद्ध ग्रामीण विकास' : 'Rural development enriched with modern amenities'}</p>
            </div>

            {/* Geographical Area Counter */}
            <div className="bg-gray-50 rounded-xl p-8 shadow-lg border border-purple-100 hover:shadow-xl transition-all duration-300 text-center group">
              <div className="mb-4">
                <div className="w-20 h-20 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto group-hover:scale-110 transition-transform duration-300">
                  <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                </div>
              </div>
              <div className="counter-number text-4xl font-bold text-purple-800 mb-2 transition-all duration-300 ease-out" data-target="1250" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>०</div>
              <h3 className="text-xl font-bold text-purple-900 mb-1">{language === 'marathi' ? 'हे. मध्ये भौगोलिक क्षेत्र' : 'Geographical Area in Ha.'}</h3>
              <p className="text-purple-700 text-sm">{language === 'marathi' ? 'विस्तीर्ण क्षेत्रफळावर विकसित ग्रामपंचायत' : 'Developed Gram Panchayat on vast area'}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-10">
            <div className="inline-block px-4 py-1 bg-gray-50 rounded-full mb-2">
              {/* <span className="text-red-800 font-semibold">व्हिडिओ</span> */}
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {language === 'marathi' ? 'मुख्यमंत्री समृद्ध पंचायत राज अभियान' : 'CM Samruddha Panchayat Raj Abhiyan'}
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-red-600 to-pink-500 mx-auto rounded-full"></div>
            <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
              {language === 'marathi' ? 'आमच्या ग्रामपंचायतीच्या विकासकार्याचा आणि उत्सवांचा व्हिडिओ दृश्य' : 'Video overview of our Gram Panchayat development works and festivals'}
            </p>
          </div>

          <div className="w-full">
            <div className="bg-white rounded-xl shadow-2xl overflow-hidden border border-gray-200">
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  src="https://www.youtube.com/embed/hV8k1VezhY4?start=9"
                  title="ग्रामपंचायत व्हिडिओ"
                  className="absolute inset-0 w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  frameBorder="0"
                ></iframe>
              </div>
              <div className="p-6 bg-gray-50">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{language === 'marathi' ? 'ग्रामपंचायत विकास कार्य' : 'Gram Panchayat Development Work'}</h3>
                    <p className="text-gray-600">{language === 'marathi' ? 'आमच्या ग्रामपंचायतीतील महत्वाच्या घडामोडी आणि विकासकार्यांचा अवलोकन' : 'Overview of important events and development works in our Gram Panchayat'}</p>
                  </div>
                  <div className="flex items-center gap-2 text-red-600">
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                    </svg>
                    <span className="font-semibold">YouTube</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* सूचना व तक्रारी Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-10">
            <div className="inline-block px-4 py-1 bg-gray-50 rounded-full mb-2">
              <span className="text-orange-800 font-semibold">{language === 'marathi' ? 'सेवा' : 'Services'}</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {language === 'marathi' ? 'सूचना व तक्रारी' : 'Notices & Complaints'}
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-orange-600 to-red-500 mx-auto rounded-full"></div>
            <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
              {language === 'marathi' ? 'आमच्या ग्रामपंचायतीसंबंधीच्या संपर्क आणि माहितीसाठीचे माध्यम' : 'Medium for contact and information regarding our Gram Panchayat'}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* संपर्क करा Card */}
            <div className="bg-gray-50 rounded-xl p-8 shadow-lg border border-green-100 hover:shadow-xl transition-all duration-300">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-green-900">{language === 'marathi' ? 'संपर्क करा' : 'Contact Us'}</h3>
              </div>

              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4 border border-green-100">
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-green-600 mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>
                    <div>
                      <p className="font-semibold text-gray-800">{language === 'marathi' ? 'फोन नंबर' : 'Phone Number'}</p>
                      <p className="text-sm text-gray-600">०२३४५-२३४५६७</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-lg p-4 border border-green-100">
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-green-600 mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                    </svg>
                    <div>
                      <p className="font-semibold text-gray-800">{language === 'marathi' ? 'मोबाईल' : 'Mobile'}</p>
                      <p className="text-sm text-gray-600">९८७६५-४३२१०</p>
                    </div>
                  </div>
                </div>
              </div>

              <button className="mt-6 w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors">
                {language === 'marathi' ? 'आता संपर्क करा →' : 'Contact Now →'}
              </button>
            </div>

            {/* ईमेल करा Card */}
            <div className="bg-gray-50 rounded-xl p-8 shadow-lg border border-blue-100 hover:shadow-xl transition-all duration-300">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-blue-900">{language === 'marathi' ? 'ईमेल करा' : 'Email Us'}</h3>
              </div>

              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4 border border-blue-100">
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-blue-600 mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                    <div>
                      <p className="font-semibold text-gray-800">{language === 'marathi' ? 'अधिकृत ईमेल' : 'Official Email'}</p>
                      <p className="text-sm text-gray-600">grampanchayat@gram.in</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-lg p-4 border border-blue-100">
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-blue-600 mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                    <div>
                      <p className="font-semibold text-gray-800">{language === 'marathi' ? 'सरपंच ईमेल' : 'Sarpanch Email'}</p>
                      <p className="text-sm text-gray-600">sarpanch@gram.in</p>
                    </div>
                  </div>
                </div>
              </div>

              <button className="mt-6 w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
                {language === 'marathi' ? 'ईमेल पाठवा →' : 'Send Email →'}
              </button>
            </div>

            {/* कार्यालयीन वेळ Card */}
            <div className="bg-gray-50 rounded-xl p-8 shadow-lg border border-orange-100 hover:shadow-xl transition-all duration-300">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-gradient-to-r from-orange-500 to-amber-500 rounded-full flex items-center justify-center mr-4">
                  <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-orange-900">{language === 'marathi' ? 'कार्यालयीन वेळ' : 'Office Hours'}</h3>
              </div>

              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4 border border-orange-100">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="font-semibold text-gray-800">{language === 'marathi' ? 'सोमवार ते शुक्रवार' : 'Monday to Friday'}</p>
                      <p className="text-sm text-gray-600">{language === 'marathi' ? 'सकाळी १०:०० ते सायंकाळी ६:००' : '10:00 AM to 6:00 PM'}</p>
                    </div>
                    <span className="bg-gray-50 text-green-800 px-2 py-1 rounded-full text-xs font-medium">
                      {language === 'marathi' ? 'उपलब्ध' : 'Available'}
                    </span>
                  </div>
                </div>

                <div className="bg-white rounded-lg p-4 border border-orange-100">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="font-semibold text-gray-800">{language === 'marathi' ? 'शनिवार' : 'Saturday'}</p>
                      <p className="text-sm text-gray-600">{language === 'marathi' ? 'सकाळी १०:०० ते दुपारी २:००' : '10:00 AM to 2:00 PM'}</p>
                    </div>
                    <span className="bg-gray-50 text-yellow-800 px-2 py-1 rounded-full text-xs font-medium">
                      {language === 'marathi' ? 'मर्यादित' : 'Limited'}
                    </span>
                  </div>
                </div>

                <div className="bg-white rounded-lg p-4 border border-orange-100">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="font-semibold text-gray-800">{language === 'marathi' ? 'रविवार' : 'Sunday'}</p>
                      <p className="text-sm text-gray-600">{language === 'marathi' ? 'बंद' : 'Closed'}</p>
                    </div>
                    <span className="bg-gray-50 text-red-800 px-2 py-1 rounded-full text-xs font-medium">
                      {language === 'marathi' ? 'बंद' : 'Closed'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="mt-6 p-4 bg-gray-50 rounded-lg border border-orange-200">
                <p className="text-sm text-orange-800 font-medium text-center">
                  {language === 'marathi' ? 'आणीबाणी कालावधीत: २४x७ उपलब्ध' : 'In Emergency: 24x7 Available'}
                </p>
              </div>
            </div>
          </div>

          {/* Contact Button Section */}
          <div className="text-center mt-12">
            <div className="bg-gray-50 rounded-xl p-8 shadow-lg border border-green-100 max-w-2xl mx-auto">
              <div className="flex items-center justify-center mb-4">
                <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center">
                  <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{language === 'marathi' ? 'तुमच्या तक्रारी किंवा सूचना आम्हाला कळवा' : 'Let us know your complaints or suggestions'}</h3>
              <p className="text-gray-600 mb-6">{language === 'marathi' ? 'आम्ही तुमच्या समस्यांचे त्वरित निराकरण करू' : 'We will resolve your issues promptly'}</p>
              <Link
                to="/contact"
                className="bg-gradient-to-r from-green-600 to-emerald-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:from-green-700 hover:to-emerald-700 transition-all duration-300 inline-flex items-center gap-3 shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
                {language === 'marathi' ? 'संपर्क करा' : 'Contact Us'}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WebsiteHome;